import { ENABLED_NOTIFICATIONS, NEW_NOTIFICATION, REMOVE_NOTIFICATION } from "../actions/type";
function notification(state = { items: [], enable: false }, action) {
    switch (action.type) {
        case NEW_NOTIFICATION:
            return {
                ...state,
                items: [...state.items, action.payload],
            };
        case ENABLED_NOTIFICATIONS:
            return { ...state, enable: true };
        case REMOVE_NOTIFICATION:
            return {
                ...state,
                items: [],
            };
        default:
            return { ...state };
    }
}

export default notification;
